import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-alert-window',
  templateUrl: './alert-window.component.html',
  styleUrls: ['./alert-window.component.scss']
})
export class AlertWindowComponent implements OnInit {

  @Input() textContent: string = '';
  @Input() confirmLabel: string = 'OK';
  @Input() title: string = 'Alert';
  @Output() confirmBtnClick = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onConfirmClick() {
    this.confirmBtnClick.emit();
  }

}
